import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, ViewChild } from '@angular/core';
import { timeParse } from 'd3-time-format';
import { scaleLinear, scaleTime } from 'd3-scale';
import { extent, max } from 'd3-array';
import * as d3Shape from 'd3-shape';
import { curveBasis } from 'd3-shape';
import { transition } from 'd3-transition';
import * as d3Selection from 'd3-selection';

@Component({
    selector: 'app-tests-chart',
    templateUrl: './tests-chart.component.html',
    styleUrls: ['./tests-chart.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TestsChartComponent implements OnChanges {
    @ViewChild('chart', { static: true })
    chartElement: ElementRef;
    parseDate = timeParse('%d-%m-%Y');

    @Input() testsStatus: any[];

    @Input() smoothCorners: boolean;

    @Input() height: number;

    @Input() width: number;

    private svgElement: HTMLElement;
    private chartProps: any;

    constructor() {
    }

    ngOnChanges() {
        this.transformData(() => {
            this.checkPathStartAndEnd();
            // if (this.testsStatus.length == 0) {
            //   console.log("NOW")
            //    this.chartProps = undefined;
            //    this.testsStatus = [];
            // }
            if (this.testsStatus && this.chartProps) {
                this.updateChart();
            } else if (this.testsStatus) {
                this.buildChart();
            }
        });
    }

    transformData(callback) {
        if (!this.smoothCorners) {

            // this.testsStatus = this.testsStatus.reverse();
        }
        this.testsStatus = this.testsStatus.map((test, i) => {
            return {number: '01-01-' + (2000 + i), testValue: test};
        });
        callback();
    }

    formatDate() {
        this.testsStatus.forEach(ms => {
            if (typeof ms.number === 'string') {
                ms.number = this.parseDate(ms.number);
            }
        });
    }

    checkPathStartAndEnd() {
        const lastTestIndex = this.testsStatus.length - 1;
        if (this.testsStatus[lastTestIndex]) {
            this.testsStatus.push({number: this.testsStatus[lastTestIndex].number, testValue: 0});
        }
        if (this.testsStatus[0]) {
            this.testsStatus.unshift({number: this.testsStatus[0].number, testValue: 0});
        }
    }


    updateChart() {
        const _this = this;
        this.formatDate();
        // var margin = { top: 30, right: 20, bottom: 30, left: 50 }, width = 600 - margin.left - margin.right;
        const margin = {top: 0, right: 0, bottom: 0, left: 0}, width = this.width - margin.left - margin.right;

        // Scale the range of the data again
        this.chartProps.x = scaleTime().range([0, (width * this.testsStatus.length) / 60]);
        this.chartProps.x.domain(
            extent(this.testsStatus, function (d) {
                if (d.number instanceof Date) {
                    return d.number.getTime();
                }
            }),
        );

        this.chartProps.y.domain([
            0,
            max(this.testsStatus, function (d) {
                return Math.max(d.testValue);
            }),
        ]);

        // Select the section we want to apply our changes to
        transition.call(this.chartProps.svg);

        // Make the changes to the line chart
        this.chartProps.svg
            .select('.line.line1') // update the line
            .attr('d', this.chartProps.valueline(this.testsStatus));

        if (this.testsStatus.length - 2 >= 60) {
            this.chartProps = undefined;
            this.testsStatus = [];
        }
    }

    buildChart() {
        this.chartProps = {};
        this.formatDate();
        this.chartElement.nativeElement.innerHTML = '';

        // Set the dimensions of the canvas / graph
        // var margin = { top: 30, right: 20, bottom: 30, left: 50 },
        //   width = 600 - margin.left - margin.right,
        //   height = 270 - margin.top - margin.bottom;

        const margin = {top: 0, right: 0, bottom: 0, left: 0},
            width = this.width - margin.left - margin.right,
            height = this.height - margin.top - margin.bottom;

        // Set the ranges
        this.chartProps.x = scaleTime().range([0, (width * this.testsStatus.length) / 60]);
        this.chartProps.y = scaleLinear().range([height, 0]);

        const _this = this;

        // Define the line
        const valueline = d3Shape
            .line<any>()
            .x(function (d) {
                if (d.number instanceof Date) {
                    return _this.chartProps.x(d.number.getTime());
                }
            })
            .y(function (d) {
                return _this.chartProps.y(d.testValue);
            });

        if (this.smoothCorners) {
            valueline.curve(curveBasis);
        }

        const svg = d3Selection
            .select(this.chartElement.nativeElement)
            .append('svg')
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', `translate(${margin.left},${margin.top})`);

        // Scale the range of the data
        this.chartProps.x.domain(
            extent(_this.testsStatus, function (d) {
                if (d.number instanceof Date) {
                    return (d.number as Date).getTime();
                }
            }),
        );
        this.chartProps.y.domain([
            0,
            max(this.testsStatus, function (d) {
                return Math.max(d.testValue);
            }),
        ]);

        // Add the valueline path.
        const gradient = svg
            .append('linearGradient')
            .attr('id', 'svgGradient')
            .attr('x1', '0%')
            .attr('x2', '100%')
            .attr('y1', '0%')
            .attr('y2', '100%');

        gradient
            .append('stop')
            .attr('class', 'start')
            .attr('offset', '0%')
            .attr('stop-color', '#3A9AF9')
            .attr('stop-opacity', 1);

        gradient
            .append('stop')
            .attr('class', 'end')
            .attr('offset', '100%')
            .attr('stop-color', '#3A9AF9')
            .attr('stop-opacity', 1);

        svg
            .append('path')
            .attr('class', 'line line1')
            .attr('stroke-width', '2px')
            .style('fill', 'url(#svgGradient)')
            .attr('d', valueline(_this.testsStatus));

        // Setting the required objects in chartProps so they could be used to update the chart
        this.chartProps.svg = svg;
        this.chartProps.valueline = valueline;
    }
}
